import React, { FC, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { useSelector } from "react-redux";
import useBodyScrollability from "@/hooks/useBodyScrollability";
import Html from "@/components/size/sizeChartPopupHtml";
import { selectProductSizeChart } from "../../selectors";
import { determineIsSizeChart } from "../../../../util/add-to-cart";
import { ProductSizeChartProps } from "../../mobileSizes/types";
import "./style.scss";

const ProductSizeChart: FC<ProductSizeChartProps> = ({
  handleSizeChartPopup
}) => {
  const sizeChart = useSelector(selectProductSizeChart);
  const { enableBodyScroll, disableBodyScroll } = useBodyScrollability();
  const onCloseSizeChartPopup = () => handleSizeChartPopup(false);
  const isSizeChart = determineIsSizeChart(sizeChart);
  const isBrandType = isSizeChart && Object.keys(sizeChart[0]).includes("list");
  const popupTitle = isSizeChart && sizeChart[0].heading;

  const isSizeChartAvailable = !!sizeChart.length && isSizeChart;
  const sizeChartHeader =
    isSizeChartAvailable &&
    (!!sizeChart[0].subCategoryName ? `- ${sizeChart[0].subCategoryName}` : "");

  useEffect(() => {
    disableBodyScroll();
    return () => {
      enableBodyScroll();
    };
  }, []);

  return (
    <div className="side_sizeChart active">
      <div className="overlay" onClick={onCloseSizeChartPopup} />
      <div className="chart_wrapper active">
        <div className="popupHeading">
          <p>{popupTitle}</p>
          <div className="close" onClick={onCloseSizeChartPopup}>
            &times;
          </div>
        </div>
        <Scrollbars style={{ height: `100vh` }}>
          {isSizeChartAvailable &&
            (isBrandType
              ? sizeChart[0].list.map(item => (
                  <Html
                    key={item.heading}
                    title={`${item.heading} ${sizeChartHeader}`}
                    html={item.html}
                  />
                ))
              : sizeChart[0] && (
                  <Html
                    title={`${sizeChart[0].brandName} ${sizeChartHeader}`}
                    html={sizeChart[0].html}
                  />
                ))}
        </Scrollbars>
      </div>
    </div>
  );
};

export default ProductSizeChart;
